<script lang="ts">
    import { transitionMealy_addSingleTransition, transitionMealy_deleteSingleTransition, transitionMealy_setSingleTransition } from '../actions/transition';
    import { mealyModelByType } from '../mealyModels/mealyModelByType';
    import type { MachineStateMealy } from '../state/machineState';
    import IconAdd from '../icons/Add.svelte';

    import MealyTransitionMenuRow from './MealyTransitionMenuRow.svelte';
    
    import { getUpdateMachineState } from "./context";
    const updateMachineProgramState = getUpdateMachineState();

    export let machineState: MachineStateMealy;
    $: uiState = machineState.uiState;
    $: transition = machineState.machine.transitions[uiState.selection.transitionId];
    $: mealyModel = mealyModelByType(machineState.mealyModelType);

    function handleCharChanged(index: number, char: string) {
        updateMachineProgramState(transitionMealy_setSingleTransition(machineState, transition.id, index, {char: char, output: transition.singleTransitions[index].output}));
    }

    function handleOutputChanged(index: number, output: string) {
        updateMachineProgramState(transitionMealy_setSingleTransition(machineState, transition.id, index, {char: transition.singleTransitions[index].char, output: output}));
    }

    function handleDeleteSingleTransition(index: number) {
        updateMachineProgramState(transitionMealy_deleteSingleTransition(machineState, transition.id, index));
    }

    function addSingleTransitionClick() {
        updateMachineProgramState(transitionMealy_addSingleTransition(machineState, transition.id, {char: '', output: ''}));
    }
</script>

<div style="position: absolute; bottom: 0px; left: 0px; border: 2px solid lightgrey; padding: 5px; margin: 5px; background-color: white; border-radius: 10px;">
    <div style="display: grid; grid-template-columns: 10em 10em 40px; column-gap: 10px;">
        <div style="grid-column: 1 / span 1; grid-row: 1 / span 1">Eingabe</div>
        <div style="grid-column: 2 / span 1; grid-row: 1 / span 1">Ausgabe</div>
        {#each transition.singleTransitions as char, index}
            <MealyTransitionMenuRow
                alphabet={mealyModel.alphabet}
                outputs={mealyModel.outputs}
                selectedChar={char.char}
                selectedOutput={char.output} 
                onCharChange={char => {handleCharChanged(index, char)}}
                onOutputChange={output => {handleOutputChanged(index, output)}}
                onDeleteClick={() => {handleDeleteSingleTransition(index)}}
            />
        {/each}

    </div>
    <div style="height: 10px;"></div>
    <button
        class="automaten-simulator-iconButton"
        on:click={addSingleTransitionClick}
    >
        <IconAdd />
    </button>
</div>